@if (isConsultantsLoading) {
  <mat-spinner mode='indeterminate' class='bench__loading'></mat-spinner>
} @else {
  <div class='bench__search-filter'>
    <mat-form-field appearance="outline">
      <mat-icon matSuffix fontIcon='search'></mat-icon>
      <input
        matInput
        (input)="searchForEntry()"
        [(ngModel)]="filter.consultantName"
        [placeholder]="'userlist.filter.name' | translate"
        type="search"
      >
    </mat-form-field>
    <button mat-mini-fab [matMenuTriggerFor]='filterMenu' [ngClass]="{ 'bench__filter': amount != 0 }">
      <mat-icon>filter_alt</mat-icon>
      @if (amount != 0) {
        - {{ amount }} / {{ 'userlistSorter.chosenConsultants' | translate }} {{ filteredConsultants?.length }} {{ 'userlistSorter.of' | translate }} {{ benchedConsultants?.length }}
      }
    </button>

    <mat-menu #filterMenu="matMenu" class="bench__menu" yPosition="below">
      <div>
        <app-dropdown-card-field
          [(ngModel)]="filter.skills"
          [items]="allSkills"
          [label]="'userlist.filter.skills' | translate"
          [displayWith]="skillLabel"
          [compareWith]="compareSkills"
          [panelClass]="'bench__select-panel'"
        ></app-dropdown-card-field>
        <mat-checkbox [(ngModel)]="filter.isSkillsAndMode" (click)='$event.stopPropagation()'>
          {{ 'userlist.filter.some' | translate }}
        </mat-checkbox>
      </div>

      <div class='bench__filter-buttons'>
        <button mat-raised-button (click)='resetFilter()'>{{ 'userlist.filter.reset' | translate }}</button>
        <button mat-flat-button (click)='applyFilter()'>{{ 'general.apply' | translate }}</button>
      </div>
    </mat-menu>
  </div>
  <mat-drawer-container class="bench__drawer-container" autosize>
    <mat-drawer class="bench__drawer-sidenav" mode="over" [(opened)]='isDrawerOpen' position='end'
                (closedStart)="onDrawerClosed()">
      <div class='bench__drawer-inner-container'>
        <button mat-icon-button (click)='isDrawerOpen=false' class='bench__close-icon'>
          <mat-icon>close</mat-icon>
        </button>
        <h2 class='bench__headline'>{{ selectedConsultant?.name }}</h2>
        <p class='bench__link' [routerLink]="['/profile/', selectedConsultant?.id]">{{ 'bench.link' | translate }}
          <mat-icon
            fontSet="material-symbols-outlined">more_up
          </mat-icon>
        </p>
        @if (selectedConsultant) {
          <form [formGroup]="form">
            <div class="bench__form-wrapper">
              <mat-form-field appearance="fill" class="bench__form-field-note">
                <mat-label>{{ 'bench.note' | translate }}</mat-label>
                <textarea matInput formControlName="note" rows="2"
                          placeholder="{{'bench.notePlaceholder' | translate}}"></textarea>
              </mat-form-field>
              <button
                matMiniFab
                aria-label="{{'bench.ariaLabel' | translate}}"
                (click)="saveNote()"
                [disabled]="!isNoteChanged">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </form>
        }

        <app-question-answer [answerLabel]='selectedConsultant?.position'
                             [questionLabel]='"bench.role" | translate'></app-question-answer>
        <app-question-answer [answerLabel]='selectedConsultant?.verfuegbar | date: "dd.MM.yyyy"'
                             [questionLabel]='"bench.available" | translate'></app-question-answer>
        <app-question-answer [answerLabel]='selectedConsultant?.wohnort'
                             [questionLabel]='"bench.placeOfResidence" | translate'></app-question-answer>
        @if (selectedConsultant?.superVisor) {
          <app-question-answer
            [answerLabel]='selectedConsultant?.superVisor?.firstName + " " + selectedConsultant?.superVisor?.lastName'
            [questionLabel]='"bench.advisor" | translate'></app-question-answer>
        }
        <p class='bench__main-focus'>{{ 'bench.mainFocus' | translate }}</p>
        <ul class='bench__main-focus-list'>@for (focus of selectedConsultant?.schwerpunkte; track focus) {
          <li>{{ focus | vocabulary:'mainFocus' }}</li>
        }</ul>
        <app-skills [consultant]='selectedConsultant' [skills]='selectedConsultant?.faehigkeiten'
                    [displayedColumns]="['skill', 'level']" [showLevelBar]='false' [editable]='false'
                    [showNoWarnings]='true' class='bench__skills'></app-skills>
      </div>
    </mat-drawer>
    <table matSort (matSortChange)='sortBench($event)' mat-table [dataSource]="filteredConsultants"
           class='bench__table'>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'bench.name' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.name }}</td>
      </ng-container>

      <ng-container matColumnDef="available">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'bench.available' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.verfuegbar | date: 'dd.MM.yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'bench.role' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.position }}</td>
      </ng-container>

      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef>{{ 'bench.note' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.note?.note }}</td>
      </ng-container>

      <ng-container matColumnDef="placeOfResidence">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'bench.placeOfResidence' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.wohnort }}</td>
      </ng-container>

      <ng-container matColumnDef="advisor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'bench.advisor' | translate }}</th>
        <td mat-cell
            *matCellDef="let element">@if (element?.superVisorId) {
          {{ element?.superVisor?.firstName }} {{ element?.superVisor?.lastName }}
        }
        </td>
      </ng-container>

      <ng-container matColumnDef='applicant'>
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="bench__column">
          {{ 'bench.applicant' | translate }}
        </th>
        <td mat-cell *matCellDef='let element' class="bench__column">
          @if (element?.applicant) {
            <mat-icon>badge</mat-icon>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="manageDrawer(row)"
        [class.bench__row--selected]="selectedConsultant?.id === row.id"
      ></tr>
    </table>
  </mat-drawer-container>
}
